export default __webpack_public_path__ + "images/f3e13a745d443a3e963c2a484c481b3d.jpg";